import React, { useContext, useEffect } from "react";
import { AppContext } from "./App";

export default function KeyboardManager() {
  const { keysRef } = useContext(AppContext);

  function keyUp(e: KeyboardEvent) {
    if (typeof keysRef.current[e.key] !== "undefined") {
      keysRef.current[e.key] = false;
    }
  }

  function keyDown(e: KeyboardEvent) {
    if (typeof keysRef.current[e.key] !== "undefined") {
      keysRef.current[e.key] = true;
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", keyDown);
    window.addEventListener("keyup", keyUp);

    return () => {
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    };
  }, []);

  return <></>;
}
